import React from 'react';
import styled from 'styled-components';
import Cards from 'components/Cards/Cards';
import CardsGroup from 'components/Cards/CardsGroup';

const IndustriesCardSection = ({ background, title, description, iconCards, ...otherProps }) => (
  <SectionContainer background={background} {...otherProps}>
    <div className="section-industries-card--wrapper">
      <h2 className="section-industries-card--title">{title}</h2>
      <div className="section-industries-card--card-content">
        {iconCards?.length > 0 && (
          <CardsGroup cols={3}>
            {iconCards.map((cardItem, index) => (
              <Cards
                bodyType={'simple'}
                title={cardItem.title}
                ctaTitle={cardItem.ctaText}
                ctaLink={cardItem.ctaLink}
                key={index}
              />
            ))}
          </CardsGroup>
        )}
      </div>
    </div>
  </SectionContainer>
);

const SectionContainer = styled.div`
  background: white;

  .section-industries-card--wrapper {
    padding: 60px 28px 80px;
    max-width: 1252px;
    margin: 0 auto;

    .section-industries-card--title {
      font-weight: 900;
      font-size: 18px;
      line-height: 120%;
    }

    .section-industries-card--card-content {
      margin-top: 20px;

      .section-industries-card--card-container {
        margin-bottom: 40px;
      }
    }
  }

  @media (max-width: 768px) {
    .section-industries-card--wrapper {
      padding: 50px 21px;
    }
  }

  @media (max-width: 576px) {
    .section-industries-card--wrapper {
      padding: 35px 21px;

      .section-industries-card--card-content {
        margin-top: 24px;

        .section-industries-card--card-container {
          margin-bottom: 0;

          & > .ant-col {
            margin-bottom: 16px;
          }
        }
      }
    }
  }
`;

export default IndustriesCardSection;
